import { render } from "./Attentions.vue?vue&type=template&id=3ed05b88"
import script from "./Attentions.vue?vue&type=script&lang=js"
export * from "./Attentions.vue?vue&type=script&lang=js"
script.render = render

export default script